import React, { useState, useEffect } from "react";
import classnames from "classnames";
import HomeIcon from "../images/home-btn@2x.png";
import HomeIconHover from "../images/home-btn-hover@2x.png";
import { Link, useLocation } from "react-router-dom";

const DeviceAlert = () => {
	let location = useLocation();
	return (
		<div className={classnames("display-mobile")}>
			Your screen is too small to experience this interactive guide. Please use a larger screen size.
		</div>
	);
};

export default DeviceAlert;
